/** Canvas visibility lenses — decouple stored IR from what is painted. */

import { componentMatchesActiveHat } from './hatVisibility.js';

export const VISIBILITY_LENSES = {
  CLEAN: 'clean',
  SELECTION: 'selection',
  HAT: 'hat',
  ISSUE: 'issue',
  VECTORS: 'vectors',
};

export const LENS_OPTIONS = [
  { id: VISIBILITY_LENSES.CLEAN, label: 'Clean' },
  { id: VISIBILITY_LENSES.HAT, label: 'Labels' },
  { id: VISIBILITY_LENSES.VECTORS, label: 'Vectors' },
];

/**
 * Whether component bbox overlays should paint for the current lens.
 */
export function shouldShowLabelOverlays({
  visibilityLens,
  issueHighlightOnly,
  previewComponentId,
  highlightComponentId,
  issueHighlightText,
}) {
  if (previewComponentId) return true;
  if (issueHighlightOnly && (highlightComponentId || issueHighlightText)) return true;
  if (visibilityLens === VISIBILITY_LENSES.CLEAN) return false;
  if (visibilityLens === VISIBILITY_LENSES.VECTORS) return false;
  if (visibilityLens === VISIBILITY_LENSES.SELECTION) {
    return Boolean(highlightComponentId);
  }
  return visibilityLens === VISIBILITY_LENSES.HAT;
}

export function shouldShowVectorMarkups({ visibilityLens }) {
  return visibilityLens === VISIBILITY_LENSES.VECTORS;
}

/**
 * Filter components for hat lens + optional filters.
 */
export function filterComponentsForLens(components, {
  visibilityLens,
  highlightComponentId,
  activeHatId,
  labelFilters,
  sheetIr,
}) {
  if (!Array.isArray(components)) return [];

  if (visibilityLens === VISIBILITY_LENSES.SELECTION) {
    return highlightComponentId
      ? components.filter((c) => c.id === highlightComponentId)
      : [];
  }

  if (visibilityLens === VISIBILITY_LENSES.ISSUE) {
    return highlightComponentId
      ? components.filter((c) => c.id === highlightComponentId)
      : [];
  }

  if (visibilityLens !== VISIBILITY_LENSES.HAT) return [];

  let list = components;

  if (labelFilters?.axis && labelFilters.axis !== 'all') {
    list = list.filter((c) => c.taxonomyAxis === labelFilters.axis);
  }
  if (labelFilters?.kind && labelFilters.kind !== 'all') {
    list = list.filter((c) => c.kind === labelFilters.kind);
  }
  if (labelFilters?.status && labelFilters.status !== 'all') {
    list = list.filter((c) => c.mappingStatus === labelFilters.status);
  }

  if (activeHatId && activeHatId !== 'architect') {
    list = list.filter((c) => componentMatchesActiveHat(c, activeHatId, sheetIr));
  }

  return list;
}
